import React, { useEffect, useState } from "react";
import { HStack, CheckboxGroup, Stack,Text } from "@chakra-ui/react"
import DotRadio from "../../theme/DotRadio";
import Tooltip from "../../theme/Tooltip";


export default function ColorRadios(props) {
  const { onChange, selectedValue, colorItems } = props;
  const [value, setValue] = useState("");
  
  useEffect(() => {
    setValue(selectedValue)
  }, [selectedValue])

  return (
    <Stack gap="4">
      <CheckboxGroup
        value={[value]}
        onValueChange={(vals) => {
          const lastSelected = vals[vals.length - 1];
          setValue([lastSelected]);
          onChange(lastSelected)
        }}
      >        
        <HStack spacing={4} wrap="wrap">
          {
            colorItems.map((color) => (
              <Tooltip 
                content={`${color.name} (${color.count || 0})`} 
                positioning={{ placement: "top" }} 
                key={color.name}
              >
                <DotRadio
                  key={color.name}
                  baseColor={color.hex} 
                  tickColor="#ffff"
                  slug={`${color.name}__${color.hex}`}
                />
              </Tooltip>
            ))
          }
          {colorItems.length === 0 && <Text fontSize="xs" color="gray.500">No colors available</Text>}
        </HStack>
      </CheckboxGroup>
    </Stack>
  );
}